export enum AppLanguage {
  POLISH = 'pl',
  UKRAINIAN = 'ua'
}
